export default {
  methods: {
    getSession: function (sessionKey) {
      var data = JSON.parse(sessionStorage.getItem(sessionKey))
      if (data == null) {
        data = []
      }
      return data
    }
  }
}
